import { ErrorHandler, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideNotificationService, ToastNotificationService } from '@lx/shared/logger';
import { GlobalErrorHandler, HttpErrorInterceptor, WHITELISTED_ERROR_CODES } from '@lx/shared/errors';

export const getErrorHandlerProviders = () =>
  [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: WHITELISTED_ERROR_CODES, useValue: [404] },
    provideNotificationService(ToastNotificationService),
  ] as Provider[];
